<template>
    <l-map
        :zoom="mapZoom"
        :center="[52.7688857, 16.7427272]"
        :options="mapOptions"
    >
        <l-control :options="{position: 'bottomleft'}">
        <div class="nf_map_legend">
            <h4>Facilities types</h4>
            <i style="background: #2A81CB"></i><span>ACTRIS Facility</span><br />
            <i style="background: #CAC428"></i><span>EARLINET Facility</span><br />
        </div>
        </l-control>
        <l-tile-layer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        layer-type="base"
        :attribution="attribution"
        ></l-tile-layer>
        <l-marker v-for="nf in nationalFacilities" :key="nf.id" :lat-lng="getNfMapPosition(nf)" :icon="markerIcon(nf)" @popupopen="popupOpened(nf.id)">
            <l-tooltip :options="{permanent: true}">
                {{nf.acronym}}
            </l-tooltip>
            <l-popup>
                <h4>{{nf.acronym}}</h4>
                <p>Status: <strong>{{nf.displayed_status.name}}</strong></p>
                <p>Contact: <strong>{{ nf.pi_name }}</strong>&nbsp;
                  <el-button v-if="!facilityInformation.pi_contact" @click.stop="setMail(nf.pi_contact)" class="ms-2" type="primary" size="small" plain icon="Message" circle />
                  <a :href="`mailto:${facilityInformation.pi_contact}`">{{ facilityInformation.pi_contact }}</a>
                </p>
                <div v-loading="facilityInformationLoading">
                    <p><strong>Lidar systems:</strong>
                    </p>
                    <ul>
                        <li v-for="lidar in facilityInformation.lidars" :key="lidar.id">
                          <el-link :href="$router.resolve({name: 'LidarLandingPage', params: {lidarId: lidar.id}}).href">{{lidar.name}}</el-link>
                        </li>
                    </ul>
                    <p><strong>Photometer systems:</strong></p>
                    <ul>
                        <li v-for="photometer in facilityInformation.photometers" :key="photometer._id">
                        {{photometer.name}}
                        </li>
                    </ul>
                </div>
            </l-popup>
        </l-marker>
    </l-map>
</template>

<script>
import api from '@/lib/api'

import "leaflet/dist/leaflet.css"
import { LMap, LTileLayer, LMarker, LPopup, LTooltip, LControl } from "@vue-leaflet/vue-leaflet"
import { icon } from 'leaflet'

export default {
    name: 'FacilityMap',
    components: {
      LMap,
      LTileLayer,
      LMarker,
      LPopup,
      LTooltip,
      LControl
    },
    data: () => ({
      nationalFacilities: [],
      facilityInformationLoading: true,
      facilityInformation: {
        lidars: [],
        photometers: []
      },
      mapZoom: 3.5,
      mapOptions: {
        zoomSnap: 0.5
      },
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      blueMarkerIcon: icon({
        iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-blue.png',
        shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41]
      }),
      yellowMarkerIcon: icon({
        iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-yellow.png',
        shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41]
      }),
    }),
    computed: {
    },
    methods: {
      getNfMapPosition (nf) {
        return [ nf?.latitude, nf?.longitude ]
      },
      markerIcon (nf) {
        if (nf.type?.code === 'actris') {
          return this.blueMarkerIcon
        }

        return this.yellowMarkerIcon
      },
      getCertifiedNationalFacilities (page = 1, perPage = 100) {
        api.facilities.getFacilities({
            per_page: perPage,
            page: page,
            displayed: true
        }).then(response => {
          if (response.data.pagination.pages > page) {
              return response.data.national_facilities.concat ( this.getCertifiedNationalFacilities (page+1, perPage) )
          }

          this.nationalFacilities = response.data.national_facilities
        }).catch(() => {})
      },
      loadFacilityInformation (facilityId) {
        this.facilityInformationLoading = true

        api.facilities.getFacility (facilityId).then (() => {
            this.facilityInformationLoading = false
        })
      },
      popupOpened (facilityId) {
        this.facilityInformationLoading = true
        this.facilityInformation.lidars = []
        this.facilityInformation.photometers = []
        this.facilityInformation.pi_contact = undefined

        api.facilities.getFacilityInstruments(facilityId).then(response => {
          this.facilityInformation.lidars = response.data.lidars
          this.facilityInformation.photometers = response.data.photometers
          this.facilityInformationLoading = false
        })
      },
      setMail (address) {
        this.facilityInformation.pi_contact = address
      }
    },
    mounted () {
        this.getCertifiedNationalFacilities ()
    }

}
</script>

<style>
.nf_map_legend {
  padding: 6px 8px;
  font-size: 12px;
  background: white;
  background: rgba(255,255,255,0.8);
  line-height: 24px;
  color: #555;
}

.nf_map_legend h4 {
  font-size: 16px;
  margin: 2px 0 8px;
  color: #555;
}

.nf_map_legend span {
  position: relative;
  bottom: 3px;
}

.nf_map_legend i {
  width: 18px;
  height: 18px;
  float: left;
  margin: 0 8px 0 0;
}
</style>